import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoFingerUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "#9095B5",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 2.31055C7.99999 1.79629 7.60268 1.37584 7.09831 1.33724L4.78516 6.54167C4.75201 6.61624 4.71166 6.68611 4.66667 6.75195V13.3333H10.9505C11.6086 13.3333 12.1688 12.8529 12.2689 12.2025L12.9863 7.53581C13.1104 6.72822 12.4857 6 11.6686 6H9.33333C8.59695 6 8 5.40305 8 4.66667V2.31055ZM1.33333 12.6667C1.33333 13.0349 1.63181 13.3333 2 13.3333H3.33333V7.33333H2C1.63181 7.33333 1.33333 7.63181 1.33333 8V12.6667ZM9.33333 4.66667H11.6686C13.303 4.66667 14.5532 6.12358 14.3047 7.73893L13.5866 12.4056C13.3864 13.7064 12.2667 14.6667 10.9505 14.6667H2C0.895431 14.6667 0 13.7712 0 12.6667V8C0 6.89543 0.895431 6 2 6H3.56706L5.91276 0.721354L5.95182 0.640625C6.16202 0.248205 6.57282 0 7.02279 0L7.14193 0.00325521C8.36263 0.0652712 9.33333 1.07443 9.33333 2.31055V4.66667Z" })
});
export default SvgIcoFingerUp;
